import React, { useState, useEffect, useRef, useCallback } from "react";
import SpeAccDataService from "../services/SpeAccService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const SpeAccPr = (props) => {
  const [speAcc, setSpeAcc] = useState([]);
  const speAccRef = useRef();
  speAccRef.current = speAcc;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveSpeAcc = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    SpeAccDataService.getAll(target)
      .then((response) => setSpeAcc(response.data || []))
      .catch((e) => { console.error(e); setSpeAcc([]); });
  }, [owner]);

  useEffect(() => { retrieveSpeAcc(); }, [retrieveSpeAcc]);

  const deleteSpeAcc = useCallback((rowIndex) => {
    const id = speAccRef.current[rowIndex].id || speAccRef.current[rowIndex]._id;
    SpeAccDataService.remove(id)
      .then(() => {
        const newArr = [...speAccRef.current];
        newArr.splice(rowIndex, 1);
        setSpeAcc(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/speacc/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/speacc/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = speAccRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteSpeAcc(idx);
  }, [deleteSpeAcc]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={speAcc}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default SpeAccPr;
